<template>
    <section class="home">
      <!-- <img src="@/assets/images/logo_home.png" class="logo_home" alt="logo">
      <h4 class="text-center text-close mb-2">تم غلق الموقع الان لمعرفة حالة حجزك بالقبول او الرفض عن طريق رقم حجز الطالب الخاص به برجاء متابعه الموقع خلال ال72 ساعة القادمة</h4>
      <router-link to="/search" class="btn PrimaryButton">معرفة حالة الحجز</router-link> -->
      <!-- <h4 class="mb-3">تم بدأ حجز الصف الثالث الإعدادي</h4>
      <router-link to="/reservation" class="btn revButton">احجز</router-link> -->
    </section>
  </template>
  
  <script>
  export default {
    name: "error-page",
  }
  </script>
  